import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const EnterpriseManagementModule = React.lazy(() => import("./EnterpriseManagementModule"));
const MembersPage = React.lazy(() => import("./pages/MembersPage/MembersPage"));
const TransactionsPage = React.lazy(() => import("./pages/TransactionsPage/TransactionsPage"));
const SecurityPage = React.lazy(() => import("./pages/SecurityPage/SecurityPage"));
const ClientSettingsPage = React.lazy(() => import("./pages/ClientSettingsPage/ClientSettingsPage"));
const EnterpriseOverviewPage = React.lazy(
  () => import("./pages/EnterpriseOverviewPage/EnterpriseOverviewPage"),
);
const EnterpriseProjectGroupsPage = React.lazy(
  () => import("./pages/EnterpriseProjectGroupsPage/EnterpriseProjectGroupsPage"),
);

export const EnterpriseManagementModuleRoutes: RouteObject = {
  path: ":clientId/manage-enterprise/*",
  element: (
    <ModuleRoute
      El={EnterpriseManagementModule}
      moduleName="enterprise-management"
      inPolicy="SharedViewerEnterpriseAdmin"
    />
  ),
  children: [
    {
      path: "admin-dashboard",
      element: <Navigate to={"/manage-enterprise/overview"} />,
    },
    {
      path: "overview",
      element: <PageRoute El={EnterpriseOverviewPage} />,
    },
    {
      path: "members",
      element: <PageRoute El={MembersPage} />,
    },
    {
      path: "transactions/:tab?",
      element: <PageRoute El={TransactionsPage} />,
    },
    {
      path: "security",
      element: <PageRoute El={SecurityPage} />,
    },
    {
      path: "settings",
      element: <PageRoute El={ClientSettingsPage} ff="ProjectNarratives" />,
    },
    {
      path: "groups",
      element: <PageRoute El={EnterpriseProjectGroupsPage} />,
    },
    {
      path: "",
      element: <Navigate to={"overview"} />,
    },
  ],
};
